import * as React from "react";
import { useNavigate } from "@tanstack/react-router";
import { AmbientBackground } from "@/components/landing";
import {
  AuthCard,
  AuthDivider,
  LoginForm,
  GoogleButton,
} from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "@tanstack/react-router";

export function LoginPage() {
  const navigate = useNavigate();
  const { signInWithGoogle, loading, user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/dashboard" });
    }
  }, [user, navigate]);

  const handleSuccess = () => {
    navigate({ to: "/dashboard" });
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <AmbientBackground />

      <AuthCard
        title="Welcome backs"
        description="Sign in to your account to continue"
        footer={
          <>
            Don't have an account?{" "}
            <Link
              to="/signup"
              className="text-primary hover:underline font-medium"
            >
              Sign up
            </Link>
          </>
        }
      >
        <LoginForm onSuccess={handleSuccess} />
        <AuthDivider />
        <GoogleButton onClick={handleGoogleSignIn} loading={loading} />
      </AuthCard>
    </div>
  );
}

export default LoginPage;
